import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Redirect } from 'react-router-dom'
import { Button, Form, Grid, Label } from 'semantic-ui-react'
import { saveDataAction } from './accions'
import { saveTypeCompany } from "../Step1/accions";
import Steps from '../../components/Steps'
import '../../genericStyles.css'

export class Step2 extends Component {
    state = {
        showMessage: false,
        showSentMessage: false,
        message: '',
        redirectToReferrer: false,
        text2: '',
        isSociety: false,
        lastName: '',
        name: '',
        phone: '',
        website: '',
        fanPage: '',
        linkedIn: '',
        twitter: '',
        banco: ''
    }

    static propTypes = {
        company: PropTypes.any,
        email: PropTypes.any,
        message: PropTypes.any
    }

    static defaultProps = {
        email: '',
        message: ''
    }

    componentWillMount() {
        if (this.props.displayData)
            this.setState({ email: this.props.email, name: this.props.displayData.nombreCompleto, phone: this.props.displayData.telefono })
        else
            this.setState({ email: this.props.email })
        if (this.props.company === 'S.A. o S.R.L.') {
            this.setState({
                isSociety: true
            });
        }
        if (this.props.message !== 'done') {
            this.setState({
                message: this.props.message,
                showMessage: true,
                _loading: false
            })
        } else {
            this.setState({
                redirectToReferrer: true,
            })
        }
        if (window.location.pathname === '/') {
            this.setState({ banco: 'credility' });
        } else {
            this.setState({ banco: window.location.pathname.split('/')[1] });
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            message,
            company
        } = nextProps;
        if (company === 'S.A. o S.R.L.') {
            this.setState({
                isSociety: true
            });
        }
        if (message !== 'done') {
            this.setState({
                message: message,
                showMessage: true,
                _loading: false
            })
        } else {
            this.setState({
                redirectToReferrer: true,
            })
        }

    }

    handleSubmit = () => {
        const {
            name,
            phone,
            website,
            fanPage,
            linkedIn,
            twitter,
        } = this.state

        const {
            email
        } = this.props

        if (name !== '' && phone !== '') {
            // const nameComplete = `${lastName} ${name}`
            this.props.handleSave({
                email,
                name,
                phone,
                website,
                fanPage,
                linkedIn,
                twitter
            })

            this.setState({
                redirectToReferrer: true,
                _loading: true
            })
        } else {
            alert('Debe completar campos obligatorios (*)')
        }
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    render() {
        const {
            redirectToReferrer,
            showMessage,
            _loading,
            message,
            isSociety,
            banco
        } = this.state

        const title = 'Contacto'
        const textInformative = '¿Podés dejarnos por favor tu nombre y un teléfono por si tenemos que contactarte para ayudarte en algún momento?'
        const textInformative2 = '¡Prometemos no molestarte con ofertas!'
        const text2 = 'Si tu empresa usa redes sociales vamos a poder conocer un poco más de ella y podremos ofrecerte un mejor crédito.'

        if (redirectToReferrer) {
            return <Redirect to={{ pathname: '/' + banco + '/step2' }} />;
        }

        return (
            <Grid centered>
                <Grid.Row stretched>
                    <Grid.Column>
                        <Steps step={0} rSocial={isSociety} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Column mobile={14} tablet={10} computer={10}>
                    <h2 className={`h2-${banco}`}> {title} </h2>
                    <Form onSubmit={this.handleSubmit} loading={_loading}>
                        <p>
                            {textInformative}
                        </p>
                        <p>
                            {textInformative2}
                        </p>
                        <Form.Input
                            label='Nombre Completo'
                            placeholder='Nombre Completo'
                            name='name'
                            onChange={this.handleChange}
                            type='input'
                            required
                            value={this.state.name}
                        />
                        {/* <Form.Input
                            label='Apellido'
                            placeholder='Apellido'
                            name='lastName'
                            onChange={this.handleChange}
                            type='input'
                            required
                        /> */}
                        <Form.Input
                            label='Teléfono'
                            placeholder='Teléfono'
                            name='phone'
                            onChange={this.handleChange}
                            type='input'
                            required
                            value={this.state.phone}
                        />
                        <br />
                        <p>
                            {text2}
                        </p>
                        <Form.Input
                            placeholder='Website del negocio'
                            name='website'
                            onChange={this.handleChange}
                            type='input'
                            label='Website'
                        />
                        <Form.Input
                            placeholder='Fan Page'
                            name='fanPage'
                            onChange={this.handleChange}
                            type='input'
                            label='Página de Facebook'
                        />
                        <Form.Input
                            placeholder='LinkedIn de la empresa'
                            name='linkedIn'
                            onChange={this.handleChange}
                            type='input'
                            label='Perfil de Linkedin'
                        />
                        <Form.Input
                            placeholder='Twitter de la empresa'
                            name='twitter'
                            onChange={this.handleChange}
                            type='input'
                            label='Perfil en Twitter'
                        />
                        <Button className={`button-${banco}`} type='submit'>Continuar</Button>
                    </Form>
                    <br />
                    {
                        showMessage && message !== '' ? (
                            <Label color='red' key='red'>
                                {message}
                            </Label>
                        ) : (
                                <span />
                            )
                    }
                </Grid.Column>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => ({
    email: state.step1Reducer.email,
    message: state.step2Reducer.messageStep2,
    company: state.step1Reducer.company ? state.step1Reducer.company : state.loginReducer.isSociety,
    displayData: state.callbackReducer.previewData
    // company: state.loginReducer.isSociety
})

const mapDispatchToProps = (dispatch) => ({
    handleSave: (payload) => dispatch(saveDataAction(payload)),
    handleCompany: (company) => dispatch(saveTypeCompany(company))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Step2))



// WEBPACK FOOTER //
// ./src/conteiners/Step2/index.js